/**
 */

export function basename(path: string, ext?: string): string {
  let name = path.split('/').pop() || '';
  if (ext && ext.charAt(0) === '.' && name.length > ext.length) {
    let len = ext.length;
    if (ext === name.slice(-len)) {
      name = name.slice(0, name.length - len);
    }
  }
  return name;
}

export function extname(path: string): string {
  let name = path.split('/').pop() || '';
  name = name.replace(/^\.+/, '');
  let index = name.lastIndexOf('.');
  return index === -1 ? '' : name.slice(index);
}
